function Help() {
  return (
    <div>
      <h4>Indicadores</h4>

      <p>
        <span className="mod-ind"> PM 10</span> &emsp; Material Particulado
        menor a 10 micrómetros Mezcla compleja de partículas líquidas o sólidas
        que provienen de fuentes naturales o de fuentes antropogénicas, poseen
        un tamaño aerodinámico menor a 10 micrómetros.
      </p>

      <p>
        <span className="mod-ind"> PM 2.5</span>
        &emsp; Mezcla Compleja de Partículas líquidas o sólidas que provienen
        principalmente de fuentes antropogénicas, poseen un tamaño aerodinámico
        menor a 2.5 micrómetros.
      </p>
      <p>
        <span className="mod-ind"> O3</span>
        &emsp; Ozono Gas compuesto por 3 átomos de oxigeno que se encuentra
        principalmente en la estratosfera, puede formarse a nivel superficial
        debido a condiciones de alta radiación y temperatura.
      </p>
      <p>
        <span className="mod-ind"> CO</span>
        &emsp; Monóxido de Carbono Gas incoloro que se forma principalmente por
        la combustión de gasolinas, leña o carbón, este compuesto, en altas
        concentraciones puede ser muy nocivo a la salud.
      </p>
      <p>
        <span className="mod-ind"> SO2</span>
        &emsp; Dióxido de Azufre Es un gas formado por 2 átomos de oxígeno y uno
        de azufre, se forma principalmente por la combustión de combustibles
        fósiles con alto contenido de azufre.
      </p>
      <p>
        <span className="mod-ind"> NO2</span>
        &emsp; Dióxido de Nitrógeno Molécula con 2 átomos de oxígeno y uno de
        Nitrógeno que se produce principalmente por la combustión de
        combustibles fósiles empleados en vehículos y plantas de energía.
      </p>
    </div>
  );
}

export default Help;
